/**
 * 提供API接口以及全局存储空间
 *
 * @author 张子超
 * @since 2018-04-04
 */
import userApi from "./user-api";
import productApi from "./product-api";
import orderApi from "./order-api";
import homepageApi from "./homepage-api";
import cartApi from "./cart-api";
import store from "./store";
import pagestate from "./pagestate";
import walletApi from "./wallet-api";
import easyApi from "./easy-api";
import chargeApi from "./charge-api";
import lotteryApi from "./lottery-api";
import jifentongApi from "./jifentong-api";
import superBusinessCardApi from "./superBusinessCard-api";

import Vue from "vue";

var api = {
  store,
  pagestate,
  user: userApi,
  product: productApi,
  order: orderApi,
  wallet: walletApi,
  homepage: homepageApi,
  cart: cartApi,
  easy: easyApi,
  charge: chargeApi,
  lottery: lotteryApi,
  jifentong: jifentongApi,
  superBusinessCard: superBusinessCardApi,
};

Vue.prototype.API = api;

export default api;



// WEBPACK FOOTER //
// ./src/api/index.js